














import { Component, Prop, Vue } from "vue-property-decorator";

// TODO: Look into web sharing API.
@Component
export default class CopyField extends Vue {
  $refs!: {
    input: HTMLInputElement;
  };

  @Prop({ required: true }) value!: string;

  fieldValue = "";

  mounted(): void {
    this.fieldValue = this.value;
  }

  onEvent(event: Event): void {
    // Disabling the input field prevents selecting the text so we override a set of event handlers to
    // make sure the value can be easily selected and copied but not be modified.
    event.preventDefault();
    this.fieldValue = this.value;
    this.$refs.input.select();
  }
}
